import { z } from 'zod';

export const entityTypeSchema = z.enum([
    'family',
    'cluster',
    'role',
    'level',
    'competency',
    'skill',
    'job_architecture',
    'user',
]);

export type EntityType = z.infer<typeof entityTypeSchema>;

export const entityIdentifierSchema = z.object({
    id: z.uuid().nullable().optional(),
    jobArchitectureId: z.uuid().nullable().optional(),
    type: entityTypeSchema,
});

export type EntityIdentifier = z.infer<typeof entityIdentifierSchema>;
